import React from 'react';
export function Header() {
  return <header className="flex items-center gap-3 px-4 py-4 bg-white border-b border-gray-200" data-id="element-57">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9jjij9zTdgXHXrJyRN6ABS/BoL_logo2.png" alt="Bridges of Life Logo" className="w-12 h-12 object-contain" data-id="element-58" />
      <h1 className="text-[20px]" style={{
      fontFamily: "'Playwrite US Modern', cursive"
    }} data-id="element-59">
        Bridges of Life
      </h1>
    </header>;
}